import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import CommonTable, { ITableColumn } from '@/components/common/CommonTable';
import FilterComponent from '@/components/common/FilterComponent';
import MainHeading from '@/components/common/MainHeading';
import TopLable from '@/components/common/TopLable';
import ApprovedLeaveIcon from '@/components/Icons/ApprovedLeaveIcon';
import CasualLeaveIcon from '@/components/Icons/CasualLeaveIconl';
import DeleteIcon from '@/components/Icons/DeleteIcon';
import EditIcon from '@/components/Icons/EditIcon';
import EmployeeLeaveIcon from '@/components/Icons/EmployeeLeaveIcon';
import PendingLeave from '@/components/Icons/PendingLeaves';
import PlusIcon from '@/components/Icons/PlusIcon';
import ViewIcon from '@/components/Icons/ViewIcon';
import CardLayout from '@/components/Layout/CardLayout';
import Layout from '@/components/Layout/Layout';
import ConfirmModal from '@/components/Modal/ConfirmModal';
import useFilter from '@/hooks/useFilter';
import {
  IDeleteResponse,
  IFilterSideBarForm,
  IPageInfo,
  ITableRowData,
} from '@/interfaces/common.model';
import { IHolidayModal } from '@/interfaces/holiday.model';
import { setUpdateFilterStates } from '@/redux/features/UserSlice';
import { RootState } from '@/redux/store';
import {
  calculateDaysDifference,
  formatNumber,
} from '@/utility/CommonFunctions';
import {
  getFilterUrl,
  orderByList,
  showToastNotification,
} from '@/utility/helper';
import { RoutesLink } from '@/utility/RouteLinks';
import moment from 'moment';
import { ReactNode, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { IUnpaidLeaveItem } from './LeaveDetail';
interface IPagination extends IPageInfo {
  count: number;
  searchQuery: string;
}

export interface ILeavePageStates {
  tableLoader: boolean;
  sortByDate: string[];
  leaveType: string;
}
interface ILeave {
  id: string;
  startDate: string;
  endDate: string;
  status: number;
  leaveType: string;
  reason: string;
  leaveDuration?: string;
  url?: string;
  unPaidLeave: IUnpaidLeaveItem | null;
}
interface ILeaveReqResponse {
  status: boolean;
  data: {
    pageInfo: IPageInfo;
    leave: ILeave[];
  };
}
interface ITableData extends ITableRowData {
  id: string;
  index: string;
  leaveType: string;
  startDate1: string;
  endDate1: string;
  reason: string;
  days: number;
  leaveDuration?: string;
  leaveStatus: string;
  unPaidLeave: IUnpaidLeaveItem | null;
  unpaid?: string;
}
export interface ILeaveCount {
  total: string;
  approved: string;
  pending: string;
  rejected: string;
  unpaid: string;
}

export interface IRemainingLeaveItem {
  leaveType: string;
  remainingLeave: number | string;
}

export interface IRemainingLeaveFormatted {
  label: string;
  value: string;
  icon: ReactNode;
}

export interface ILeaveCountResponse {
  status: boolean;
  data: ILeaveCount;
  message: string;
}

export interface IRemainingLeaveResponse {
  status: boolean;
  data: IRemainingLeaveItem[];
  message: string;
}

export type IGetLeaveCountResponse =
  | ILeaveCountResponse
  | IRemainingLeaveResponse;

export interface ILeaveState {
  leaveList: ITableData[];
  listType: IRemainingLeaveItem[];
  leaveCount: ILeaveCount | null;
  remainingLeave: IRemainingLeaveFormatted[];
  EditLeaveData: ITableData | null;
}

const MyLeave = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [modal, setModal] = useState<IHolidayModal>({
    updateData: false,
    deleteData: false,
  });
  const dispatch = useDispatch();
  const [selectedId, setSelectedId] = useState<string>('');
  const [state, setState] = useState<ILeaveState>({
    leaveList: [],
    listType: [],
    leaveCount: null,
    remainingLeave: [],
    EditLeaveData: null,
  });
  console?.log('state', state?.leaveCount);
  const filterDetails = useSelector(
    (state: RootState) => state?.user?.filtersStates,
  );
  const [pagination, setPagination] = useState<IPagination>({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    searchQuery: '',
  });
  const tableView = useSelector((state: RootState) => state?.user?.tableView);
  const [pageStates, setPageStates] = useState<ILeavePageStates>({
    tableLoader: false,
    sortByDate: [
      moment().startOf('month').format('YYYY-MM-DD'),
      moment().endOf('month').format('YYYY-MM-DD'),
    ],
    leaveType: '',
  });

  const toggleModal = (type?: string) => {
    setModal((pre) => ({
      ...pre,
      ...(type === 'delete'
        ? { deleteData: !pre.deleteData }
        : { updateData: !pre.updateData }),
    }));
  };

  const tableHeading: ITableColumn<ITableData>[] = [
    { value: 'index', label: '#' },
    { value: 'leaveType', label: 'Leave Type' },
    { value: 'startDate1', label: 'From' },
    { value: 'endDate1', label: 'To' },
    { value: 'days', label: 'Days' },
    // { value: 'reason', label: 'Reason' },
    { value: 'leaveStatus', label: 'Status' },
    { value: 'unpaid', label: 'Unpaid Leave' },
  ];
  const topLabelItems = [
    // {
    //   label: 'Total Leaves',
    //   value: state?.leaveCount?.total,
    //   icon: <EmployeeLeaveIcon />,
    // },
    {
      label: 'Approved Leave ',
      value: state?.leaveCount?.approved,
      icon: <ApprovedLeaveIcon />,
    },
    {
      label: 'Pending Leave Requests',
      value: state?.leaveCount?.pending,
      icon: <PendingLeave />,
    },
    {
      label: 'Rejected Leaves',
      value: state?.leaveCount?.rejected,
      icon: <EmployeeLeaveIcon />,
    },
    {
      label: 'Un-Paid Leaves',
      value: state?.leaveCount?.unpaid,
      icon: <EmployeeLeaveIcon />,
    },
    ...(state?.remainingLeave ?? ''),
  ];
  const ActionHandler = (data: ITableData) => {
    setSelectedId(data?.id);
    toggleModal('delete');
  };
  const handleEdit = (data: ITableData) => {
    if (data?.leaveStatus !== '0') {
      showToastNotification(
        'danger',
        'Can not update non-pending leave request.',
      );
      return;
    }
    setState((pre) => ({ ...pre, EditLeaveData: data }));
    navigate(RoutesLink?.addLeave, { state: data });
  };

  const ActionData = [
    {
      label: 'View',
      className: 'btn btn-link ',
      icon: <ViewIcon />,
      title: 'view',
      clickHandler: (data: ITableData) =>
        navigate(RoutesLink?.leaveDetail + `/${data?.id}`),
    },
    {
      label: 'Edit',
      className: 'btn btn-link ',
      icon: <EditIcon />,
      title: 'edit',
      clickHandler: handleEdit,
      isHidden: (data: ITableData) => data?.leaveStatus !== '0',
    },
    {
      label: 'Delete',
      className: 'btn btn-link',
      icon: <DeleteIcon />,
      title: 'delete',
      isShow: 0,
      isHidden: (data: ITableData) => data?.leaveStatus !== '0',
      clickHandler: ActionHandler,
    },
  ];

  useEffect(() => {
    getMyLeaveReq();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    pageStates?.sortByDate,
    pagination?.searchQuery,
    filterDetails?.leaveType,
    filterDetails.pageSize,
    filterDetails.currentPage,
    filterDetails?.orderBy,
  ]);
  useEffect(() => {
    getLeaveCount();
    getLeaveCount('remaining');
  }, []);

  const getMyLeaveReq = async () => {
    try {
      const filter = {
        pageNumber: pagination?.currentPage,
        search: pagination?.searchQuery,
        pageSize: filterDetails?.pageSize,
        leaveType: filterDetails?.leaveType,
        startDate: pageStates?.sortByDate[0],
        endDate: pageStates?.sortByDate[1],
        orderBy: filterDetails?.orderBy,
      };
      const API =
        API_URL +
        API_ENDPOINT?.getLeave +
        '?' +
        getFilterUrl(filter) +
        '&myLeave=true';
      setPageStates((pre) => ({
        ...pre,
        tableLoader: !pre.tableLoader,
      }));
      const res: ILeaveReqResponse = await callApi(API, {
        method: 'GET',
      });
      setPageStates((pre) => ({
        ...pre,
        tableLoader: !pre.tableLoader,
      }));

      if (res?.status === true) {
        const newData: ITableData[] = res?.data?.leave?.map((item, index) => {
          const days =
            Number(
              calculateDaysDifference(item?.startDate, item?.endDate, 'number'),
            ) || 0;
          const result =
            item?.leaveDuration == 'firstHalf' ||
              item?.leaveDuration == 'secondHalf'
              ? days * 0.5
              : days;
          return {
            id: item.id ?? '',
            index: String(index + 1),
            leaveType: item.leaveType ?? '-',
            days: result ?? '--',
            startDate1: moment(item.startDate).format('DD/MM/YYYY'),
            endDate1: moment(item.endDate).format('DD/MM/YYYY'),
            reason: item.reason ?? '-',
            leaveStatus: String(item.status ?? ''),
            leaveDuration: item?.leaveDuration,
            url: item?.url,
            unPaidLeave: item?.unPaidLeave ?? null,
            unpaid:
              item?.unPaidLeave &&
                (item?.unPaidLeave?.leaveId === item?.id ||
                  Boolean(item?.unPaidLeave?.id))
                ? 'Yes'
                : 'No',
          };
        });

        setState((pre) => ({
          ...pre,
          leaveList: newData,
        }));
        setPagination((pre) => ({
          ...pre,
          count: res?.data?.pageInfo?.total ?? 0,
          totalPages: res?.data?.pageInfo?.totalPages,
        }));
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
    }
  };

  const getLeaveCount = async (type?: string) => {
    try {
      const url =
        API_URL + API_ENDPOINT.getLeaveCount + `?type=${type ? type : 'leave'}`;
      const res: IGetLeaveCountResponse = await callApi(url, {
        method: 'GET',
      });
      if (!res?.status) {
        showToastNotification('danger', res?.message || 'Something went wrong');
        return;
      }
      if (type === 'remaining') {
        const data = (res as IRemainingLeaveResponse).data;
        setState((pre) => ({
          ...pre,
          remainingLeave: data.map((item) => ({
            label: item.leaveType,
            value: formatNumber(+item.remainingLeave),
            icon: <CasualLeaveIcon />,
          })),
          listType: data,
        }));
      } else {
        const data = (res as ILeaveCountResponse).data;
        setState((pre) => ({
          ...pre,
          leaveCount: data,
        }));
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    }
  };

  const dateChangeHandler = (Dates: Date[]) => {
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000,
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000,
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    if (formattedDate !== null) {
      setPageStates((prevState) => ({
        ...prevState,
        sortByDate: formattedDate,
      }));
      // setFilterData((prevState) => ({
      //   ...prevState,
      //   sortByDate: formattedDate,
      // }));
    } else {
      setPageStates((prevState) => ({ ...prevState, sortByDate: [] }));
      // setFilterData((prevState) => ({
      //   ...prevState,
      //   sortByDate: formattedDate,
      // }));
    }
  };
  const handleDelete = async () => {
    try {
      setIsLoading(true);
      const API = `${API_URL}${API_ENDPOINT?.deleteLeave}?leaveId=${selectedId}`;
      const response: IDeleteResponse = await callApi(API, {
        method: 'GET',
      });
      if (response?.status === true) {
        showToastNotification('success', response?.message);
        getLeaveCount();
        toggleModal('delete');
        getMyLeaveReq();
      } else {
        showToastNotification('danger', response?.message);
        toggleModal('delete');
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };
  const sortHandler = (data: Partial<IFilterSideBarForm> | null) => {
    dispatch(
      setUpdateFilterStates({
        ...data,
        leaveType: data?.leaveType ?? '',
      }),
    );
  };
  const {
    handleSearchChange,
    orderByHandler,
    handleChangePageSize,
    pageChangeHandler,
  } = useFilter(pagination, setPagination);

  return (
    <>
      <Layout>
        <div className="content">
          <MainHeading
            title="Leave"
            buttonText="Apply Leave"
            buttonIcon={<PlusIcon />}
            buttonLink={RoutesLink?.addLeave}
            dateChangeHandler={dateChangeHandler}
            showDefaultDate={true}
          />
          <TopLable items={topLabelItems} />
          <CardLayout isGrid={tableView === 'grid'}>
            <FilterComponent
              searchPlaceHolder="Search"
              handleSearch={handleSearchChange}
              orderByList={orderByList}
              orderByHandler={orderByHandler}
              filterArray={{
                isShow: true,
              }}
              sortHandler={sortHandler}
              isGrid={false}
              leaveList={state?.listType}
              handleFilterForLeave={setPageStates}
            />
            <CommonTable<ITableData>
              tableHeading={tableHeading}
              tableData={state?.leaveList}
              ActionData={ActionData}
              pageSize={filterDetails?.pageSize}
              count={pagination?.count}
              currentPage={pagination?.currentPage}
              totalPages={pagination?.totalPages}
              isLoading={pageStates?.tableLoader}
              handleChangePageSize={handleChangePageSize}
              pageChangeHandler={pageChangeHandler}
            />
          </CardLayout>
          {/* </div>
        </div> */}
        </div>
      </Layout>
      <ConfirmModal
        isOpen={modal?.deleteData}
        toggle={() => toggleModal('delete')}
        submitHandler={handleDelete}
        isLoading={isLoading}
      />
    </>
  );
};

export default MyLeave;
